import React, { useContext, useEffect } from "react";
import "./Ingredients.css";
import "./ResponsiveIngredient.css";
import Zoom from "react-reveal/Zoom";
import LightSpeed from "react-reveal/LightSpeed";
import Reveal from "react-reveal/Reveal";
import Aos from "aos";
import { motion, Variants } from "framer-motion";
import { dataContext } from "../../context/DataContextProvider";

const imageAnimate = {
  offscreen: { y: -100, opacity: 0 },
  onscreen: {
    y: 0,
    opacity: 1,
    rotate: [0, 50, 0],
    transition: { type: "spring", bounce: 0.7, duration: 4 },
  },
}

const imageAnimate2 = {
  offscreen: { y: 100, opacity: 0 },
  onscreen: {
    y: 0,
    opacity: 1,
    rotate: [0, 40, 0],
    transition: { type: "spring", bounce: 0.7, duration: 4 },
  },
};

const imageAnimate3 = {
  offscreen: { y: -100, opacity: 0 },
  onscreen: {
    y: 0,
    opacity: 1,
    rotate: [0, 30, 0],
    transition: { type: "spring", bounce: 0.7, duration: 4 },
  },
};

const imageAnimate4 = {
  offscreen: { x: 2000, opacity: 0 },
  onscreen: {
    x: 0,
    opacity: 1,
    rotate: [0, 5, 0],
    transition: { type: "spring", bounce: 0.6, duration: 7 },
  },
};

const textAnimate = {
  offscreen: { y: 100, opacity: 0 },
  onscreen: {
    y: 0,
    opacity: 1,
    // rotate: [0, -50, 0],
    transition: { type: "spring", bounce: 0.7, duration: 2 },
  },
};

const textAnimate2 = {
  offscreen: { y: -100, opacity: 0 },
  onscreen: {
    y: 0,
    // rotate: [0, 40, 0],
    opacity: 1,
    transition: { type: "spring", bounce: 0.7, duration: 2 },
  },
};

const textAnimate3 = {
  offscreen: { x: 100, opacity: 0 },
  onscreen: {
    x: 0,
    // rotate: [0, -60, 0],
    opacity: 1,
    transition: { type: "spring", bounce: 0.7, duration: 2 },
  },
};

// const Card = ({ image, h2, p, id }) => {
//   return (
//     <motion.div
//       className="card"
//       id={id}
//       initial={"offscreen"}
//       whileInView={"onscreen"}
//       viewport={{ once: false, amount: 0.5 }}
//       transition={{ staggerChildren: 0.5 }}
//     >
//       <motion.div className="image-container" variants={imageAnimate}>
//         {image}
//       </motion.div>
//       <motion.h2 variants={textAnimate}>{h2}</motion.h2>
//       <motion.p variants={textAnimate}>{p}</motion.p>
//     </motion.div>
//   );
// };

const Ingredients = () => {
  const { allWebParts } = useContext(dataContext);
  const filterAllWebParts = allWebParts?.filter(
    (x) => x.uniqueName === "ingredient"
  );

  const filetrKeyIngredient = (key) => {
    if (filterAllWebParts) {
      const result = JSON.parse(filterAllWebParts[0]?.specification)?.filter(
        (item) => {
          return item.Key === key;
        }
      );
      return result;
    }
  };
  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <div className="ingredient" id="ingredients">
      <div className="ingredient-container">
        <div className="content">
          <motion.div
            className="left-section"
            // id="ingredients"
            // data-aos="fade-up"
            // data-aos-duration="1000"
            initial={"offscreen"}
            whileInView={"onscreen"}
            viewport={{ once: false, amount: 1 }}
            transition={{ staggerChildren: 1 }}
          >
            {/* <motion.div variants={imageAnimate4}> */}
              <img
                src={filetrKeyIngredient("ingredient-image-chocotrips")?.map(
                  (item) => item.Value
                )}
                className="chocotrips"
                alt="chocotrips-img"
              />
            {/* </motion.div> */}
          </motion.div>
          <div className="right-section">
            {/* <Zoom top cascade> */}
            <motion.div
              className="box box-1"
              initial={"offscreen"}
              whileInView={"onscreen"}
              viewport={{ once: false, amount: 1 }}
              transition={{ staggerChildren: 1 }}
              // data-aos="fade-right"
              // data-aos-duration="1000"
            >
              <motion.div variants={imageAnimate}>
                <img
                  src={filetrKeyIngredient("ingredient-image1")?.map(
                    (item) => item.Value
                  )}
                  className="img-1"
                  alt="DarkChocolate"
                />
              </motion.div>
              <motion.p variants={textAnimate}>{filetrKeyIngredient("ingredient-text1")?.map(
                  (item) => item.Value
                )}</motion.p>
            </motion.div>
            <motion.div
              className="box box-2"
              initial={"offscreen"}
              whileInView={"onscreen"}
              viewport={{ once: false, amount: 0.5 }}
              transition={{ staggerChildren: 0.5 }}
              // data-aos="fade-down"
              // data-aos-duration="1000"
            >
              <motion.div variants={imageAnimate2}>
                <img
                  src={filetrKeyIngredient("ingredient-image2")?.map(
                    (item) => item.Value
                  )}
                  className="img-2"
                  alt="CrispyLayers"
                />
              </motion.div>
              <motion.p variants={textAnimate2}>{filetrKeyIngredient("ingredient-text2")?.map(
                  (item) => item.Value
                )}</motion.p>
            </motion.div>
            <motion.div
              className="box box-3"
              // data-aos="fade-left"
              // data-aos-duration="1000"
              initial={"offscreen"}
              whileInView={"onscreen"}
              viewport={{ once: false, amount: 0.5 }}
              transition={{ staggerChildren: 0.5 }}
            >
              <motion.div variants={imageAnimate3}>
                <img
                  src={filetrKeyIngredient("ingredient-image3")?.map(
                    (item) => item.Value
                  )}
                  className="img-3"
                  alt="CreamCacao"
                />
              </motion.div>
              <motion.p variants={textAnimate3}>
                {filetrKeyIngredient("ingredient-text3")?.map(
                  (item) => item.Value
                )}
              </motion.p>
            </motion.div>
            {/* </Zoom> */}
          </div>
        </div>
      </div>
      <img
        src="/pic/Third Shape.png"
        className="third-shape"
        alt="third-shape"
      />
    </div>
  );
};

export default Ingredients;
